export default "__VITE_ASSET__HO6WJOZP__"